import React, { useState, useEffect } from 'react';
import '../styles/InstallPWA.css';

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Detect iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iOS);

    // Check if already installed (standalone mode)
    const standalone = window.matchMedia('(display-mode: standalone)').matches || 
                       window.navigator.standalone === true;
    setIsStandalone(standalone);

    // Show iOS instructions if on iOS and not installed
    if (iOS && !standalone) {
      setShowInstallPrompt(true);
    }

    const handler = (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later
      setDeferredPrompt(e);
      // Show the install prompt
      setShowInstallPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;

    console.log(`User response to the install prompt: ${outcome}`);

    // Clear the deferredPrompt for the next time
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
  };

  if (!showInstallPrompt || isStandalone) {
    return null;
  }

  // iOS Instructions Banner
  if (isIOS) {
    return (
      <div className="install-pwa-banner ios-banner">
        <button onClick={handleDismiss} className="ios-close-btn" aria-label="Close">
          ✕
        </button>
        <div className="install-pwa-content ios-content">
          <div className="ios-header">
            <div className="ios-title-section">
              <h3 className="ios-title">Install HuntexLotto App on your iPhone</h3>
              <p className="ios-subtitle">Get the full app experience</p>
            </div>
          </div>
          
          <div className="ios-instructions-wrapper">
            <div className="ios-instruction-step">
              <span className="step-number">1</span>
              <div className="step-content">
                <p>Tap the <strong>Share</strong> button</p>
                <div className="ios-share-icon">
                  <svg width="20" height="26" viewBox="0 0 20 26" fill="none">
                    <path d="M10 0L10 18M10 0L6 4M10 0L14 4" stroke="currentColor" strokeWidth="2"/>
                    <path d="M2 8L2 24C2 24.5523 2.44772 25 3 25L17 25C17.5523 25 18 24.5523 18 24L18 8" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
              </div>
            </div>
            
            <div className="ios-instruction-step">
              <span className="step-number">2</span>
              <div className="step-content">
                <p>Select <strong>"Add to Home Screen"</strong></p>
                <span className="home-icon"></span>
              </div>
            </div>
            
            <div className="ios-instruction-step">
              <span className="step-number">3</span>
              <div className="step-content">
                <p>Tap <strong>"Add"</strong> to confirm</p>
                <span className="check-icon">✓</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Chrome/Android Install Button
  return (
    <div className="install-pwa-banner">
      <div className="install-pwa-content">
        <div className="install-pwa-icon">📱</div>
        <div className="install-pwa-text">
          <h3>Install HuntexLotto App</h3>
        </div>
        <div className="install-pwa-actions">
          <button onClick={handleInstallClick} className="install-btn">
            Install
          </button>
          <button onClick={handleDismiss} className="dismiss-btn">
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
